(function ($) {
    let $fn = $(".comp_contact");

    if ($fn.length) {
        let $map = $fn.find("[data-map]");

        if($map.length) {
            $.getScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyDHt8YWX5Zzs8InkVLjD9TA8aHLy-P-eaY")
                .done(function () {
                    $map.nl_google_map('init');
                    $map.nl_google_map('markers_add');
                });
        }
    }
})(jQuery);